import React, { Suspense, useEffect } from "react";
import { SiteSettingsProvider, useSiteSettings } from "./context/SiteSettingsContext";
import GatewayLoader from "./components/Gateway/GatewayLoader";
import ServiceStatusBanner from "./components/ServiceStatusBanner";
import { applySiteDocument } from "./config/siteTitles";

/** Separate chunks — Bit JS is only downloaded when Host is false (admin toggle). */
const HostApp = React.lazy(() => import(/* webpackChunkName: "host-app" */ "./HostApp"));
const BitApp = React.lazy(() => import(/* webpackChunkName: "bit-app" */ "./bit/BitApp"));

function AppGateway() {
  const { hostEnabled, loading, forcedHost } = useSiteSettings();

  useEffect(() => {
    if (loading) return;

    applySiteDocument(hostEnabled);

    const root = document.documentElement;
    root.classList.toggle("bit-active", !hostEnabled);
    root.classList.toggle("host-active", hostEnabled);
    if (!hostEnabled) {
      root.style.fontSize = "14px";
    } else {
      root.style.fontSize = "";
    }
  }, [hostEnabled, loading]);

  if (loading) return <GatewayLoader />;

  return (
    <>
      {forcedHost && process.env.NODE_ENV === "development" && (
        <div className="gateway-force-host" role="status">
          Local override: blog mode locked (<code>REACT_APP_FORCE_HOST=true</code>). Admin toggle ignored.
        </div>
      )}
      {hostEnabled ? (
        <Suspense fallback={<GatewayLoader />}>
          <HostApp />
        </Suspense>
      ) : (
        <Suspense fallback={<GatewayLoader />}>
          <BitApp />
        </Suspense>
      )}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <ServiceStatusBanner appLabel="Bitly Host" />
      <SiteSettingsProvider>
        <AppGateway />
      </SiteSettingsProvider>
    </div>
  );
}

export default App;
